<template>
  <router-link class="news-row" :to="{ name: 'NewsDetail', query: { id: item.id } }">
    <span class="news-date">{{ item.dateFmt }}</span>
    <span class="news-title">{{ item.title }}</span>
    <span class="news-arrow">›</span>
  </router-link>
</template>

<script>
export default {
  data() {
    return {
      item: {}
    }
  },
  props: {
    value: String
  },
  mounted() {
    this.item = JSON.parse(this.value);
    this.item.dateFmt = this.toDateFmt(this.item.datetime);
  },
  methods: {
    toDateFmt(datetime) {
      var date = new Date(1970, 0, 1);
      date.setSeconds(datetime.seconds);
      date.setHours(date.getHours() + 9);
      return date.getFullYear()
        + "/" + ("00" + (date.getMonth() + 1)).slice(-2)
        + "/" + ("00" + date.getDate()).slice(-2);
    },
  }
}
</script>

<style scoped>
.news-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 11px 8px;
  border-bottom: 1px solid #ece4d2;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s;
}
.news-row:hover {
  background: #faf6ec;
}
.news-date {
  flex-shrink: 0;
  color: #a99f88;
  font-size: 12px;
  white-space: nowrap;
}
.news-title {
  flex: 1;
  color: #5b564c;
  font-size: 14px;
  line-height: 1.4;
}
.news-arrow {
  flex-shrink: 0;
  color: #cdc3a8;
  font-size: 20px;
  line-height: 1;
  transition: transform 0.15s, color 0.15s;
}
.news-row:hover .news-title {
  color: #AF9453;
  text-decoration: underline;
}
.news-row:hover .news-arrow {
  color: #AF9453;
  transform: translateX(3px);
}
@media screen and (max-width: 640px) {
  .news-date { font-size: 11px; }
  .news-title { font-size: 13px; }
}
</style>
